import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RedirectPreloaderService {
  public redirectingPreloader = false;
}
